<template>
  <section>
    <banner-notice :activeBanner="activeBanner" ref="bannerNotice" />
    <fission-popup
      ref="fissionPopup"
      gameName="payResult"
      :activeBanner="activeBanner"
      v-if="!isDesktop && showFission"
    />
    <MobileShare ref="mobileShare" />
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import BannerNotice from './notice'
  import { pageBannerClick } from '@/pages/firebase'
  import { jsontoString } from '@/utils/tool'
  import FissionPopup from '@/pages/Activity/Fission/Popups'
  import { setRouteBase } from '@/config/routePrefix'
  import {
    changeTitleBarMode,
    tryToNative,
    appCloseCurWebview,
  } from '@/utils/native'
  import { MobileShare } from '@/components/PublicShare/index'
  import { jumpToPage } from '@/utils/utils'

  export default {
    name: 'banner',
    components: {
      BannerNotice,
      FissionPopup,
      MobileShare,
    },
    props: {
      page: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        activeBanner: {},
        showFission: false,
        whatsAppIslogin: false, // 点击登录之后、自动跳转
      }
    },
    computed: {
      ...mapState(['isDesktop', 'isApp']),
      ...mapGetters(['trackPage', 'isLogin']),
    },
    watch: {
      isLogin: {
        handler(newVal) {
          if (this.whatsAppIslogin && newVal) {
            this.$router_push({
              path: `/bind-mobile-phone`,
            })
          }
        },
        deep: true,
        immediate: true,
      },
    },
    created() {},
    methods: {
      ...mapMutations([
        'detail/setIsPierceLogoLayer',
        'detail/setOperateLayer',
      ]),
      init() {
        this.activeBanner = {}
        this.showFission = false
        this.shareConfig = {}
      },
      callLogin() {
        const start = Date.now()
        this['detail/setIsPierceLogoLayer'](start)
      },
      jumpPage(item, query = {}) {
        this.$emit('click', item)
        this.init()
        const { id = 0 } = item
        if (this.page !== 'pay-result' && this.page !== 'home') {
          pageBannerClick({
            list_id: id,
            page: this.trackPage,
          })
        }
        // 根据跳转类型判断
        // 1自定义跳转连接，2登陆弹框，3活动弹框，4运营弹框，5 裂变弹框 6分享
        switch (item.jumpType * 1) {
          case 1:
            // 跳转链接
            if (item.url) {
              if (this.isApp) {
                // app内跳转时恢复普通模式（非全屏）
                changeTitleBarMode(0)
              }
              if (this.isApp && this.page === 'pay-result') {
                // app内且为支付结果页，跳转时打开新webview并关闭当前webview
                tryToNative({
                  url: `${item.url}${
                    item.url.indexOf('?') > -1 ? '&' : '?'
                  }${jsontoString(query)}`,
                  params: null,
                }).then(() => appCloseCurWebview())
                return
              }

              // banner配置 引导绑定whatsApp
              if (item.url.indexOf('bind-mobile-phone') !== -1) {
                if (this.isLogin) {
                  this.$router_push({
                    path: `/bind-mobile-phone`,
                  })
                } else {
                  this.whatsAppIslogin = true
                  this.callLogin()
                }
                return
              }

              jumpToPage(
                `${item.url}${
                  item.url.indexOf('?') > -1 ? '&' : '?'
                }${jsontoString(query)}`
              )
            }
            break
          case 2:
            // 登录弹窗
            // this.$emit('login', 'banner')
            this.callLogin()
            break
          case 3:
            // 活动弹窗 - 未登录的情况下
            this.activeBanner = item
            this.$nextTick(() => {
              this.$refs.bannerNotice.getCouponData &&
                this.$refs.bannerNotice.getCouponData()
            })
            break
          case 4:
            // 运营弹框
            this['detail/setOperateLayer'](item.popupsId)
            break
          case 5:
            // 裂变
            this.$nextTick(() => {
              this.activeBanner = item
              this.showFission = true
            })
            break
          case 6: {
            // 分享
            const fix = setRouteBase() === '/' ? '' : setRouteBase()
            const shareConfig = {
              shareUrl: `${window.location.origin}${fix}/${item.game}`,
              shareTitle: this.$t('payResult.shareTip'),
              page: 'banner',
            }
            this.$refs.mobileShare &&
              this.$refs.mobileShare.setShareInfo(shareConfig)
            this.$refs.mobileShare && this.$refs.mobileShare.switch()
            break
          }
          default:
            break
        }
      },
    },
  }
</script>
